module.exports = __webpack_public_path__ + "static/media/cancel.5d56c4ea.svg";